import React from 'react';
import { useSelector } from 'react-redux';

import { Spinner } from 'triider-components';
import Header from 'components/Header';
import ModalWelcomeVideo from 'containers/ModalWelcomeVideo';
import WhatsContact from 'components/WhatsContact';
import WhatsContactBanner from 'components/WhatsContact/WhatsContactBanner';
import ContainerOrders from 'containers/ContainerOrders/index';
import ServicesPopular from 'containers/ServicesPopular/index';
import ServicesMost from 'containers/ServicesMost/index';
import Categories from 'containers/Categories/index';
import Faq from 'containers/Faq/index';
import StyledLink from 'components/StyledLink';
import ContainerStepHelp from 'containers/ContainerStepHelp';
import iconChat from 'assets/icons/general/chat.svg';

import {
  Container,
  Content,
  ServiceSubtitle,
  ContentSubtitle,
  ContentSpinner,
  HelpCenter,
} from './styles';

const Home = () => {
  const loadingVisible = useSelector(state => state.ui.loaders.includes('GETUSER'));
  const user = useSelector(state => state.auth.triiderUser && state.auth.triiderUser.user);
  return (
    <Container>
      <Header />
      <Content>
        <ModalWelcomeVideo />
        <ContainerStepHelp />
        {loadingVisible ? (
          <ContentSpinner>
            <Spinner size="larger" />
          </ContentSpinner>
        ) : (
          <>
            {user?.name && (
              <>
                <ServiceSubtitle>Meus serviços</ServiceSubtitle>
                <ContainerOrders />
              </>
            )}
            <ContentSubtitle>Serviços populares</ContentSubtitle>
            <ServicesPopular />
            <ContentSubtitle>Mais serviços</ContentSubtitle>
            <ServicesMost />
            <ContentSubtitle>Categorias</ContentSubtitle>
            <Categories />
            <ContentSubtitle>Perguntas frequentes</ContentSubtitle>
            <Faq />
          </>
        )}
        <HelpCenter>
          <div>Não encontrou o que procura?</div>
          <StyledLink primary href="#">
            <img style={{ marginRight: 8 }} src={iconChat} width="20" height="20" alt="ìcone de chat" />
            Fale com a nossa central ajuda
          </StyledLink>
        </HelpCenter>
      </Content>
    </Container>
  );
};

export default Home;
